module.exports = __webpack_public_path__ + "img/groups_black_32dp_30.1137d200.png";